import { render, staticRenderFns } from "./PriceConfigDialog.vue?vue&type=template&id=a7fad2ee&scoped=true"
import script from "./PriceConfigDialog.vue?vue&type=script&lang=js"
export * from "./PriceConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./PriceConfigDialog.vue?vue&type=style&index=0&id=a7fad2ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fad2ee",
  null
  
)

export default component.exports